import { defineComponent } from "vue";
import common from "../core/core";

export default defineComponent({
  data() {
    return {
      menuIdArray: [] as number[],
    };
  },
  async mounted() {
    await this.$store.direct.getters.customerService.getIsCustomer();
  },
  methods: {
    toggleMenu(id: number) {
      if (this.menuIdArray.includes(id)) {
        const i = this.menuIdArray.findIndex((i) => i === id);
        if (i > -1) {
          this.menuIdArray.splice(i, 1);
        }
      } else {
        this.menuIdArray.push(id);
      }
    },
    isActive(id: number) {
      return this.menuIdArray.includes(id);
    },
  },
  mixins: [common],
});
